<template>
  <modal
    width="80%"
    height="550px"
    name="job-log"
    @closed="close">
    <div class="pull-right">
      <a @click="hide" aria-label="Close" class="close">
        <span aria-hidden="true">&times;</span>
      </a>
    </div>
    <div v-if="job">
      <div class="card border-light">
        <div class="card-body">
          <h4 class="card-title">{{job.name}}</h4>
          <h6 class="card-subtitle mb-2 text-muted">
            Started:
            {{job.started | moment('MMMM Do YYYY h:mma')}}
          </h6>
        </div>
        <pre class="pre-scrollable border">
          <div v-for="event in job.logs">{{event.message}}</div>
        </pre>
        <div class="card-body">
          <div class="pull-right">
            <a href="javascript:void(0)" @click="hide" class="card-link">Dismiss</a>
          </div>
          <a target="_blank" :href="'https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logEventViewer:group=/aws/batch/job;stream=' + job.stream">
            CloudWatch Logs
          </a>
        </div>
      </div>
    </div>
    <div class="loading" v-else>
      <a @click="hide">
        <i title="Job is in progress" class="text-primary fa fa-spinner fa-spin fa-5x" aria-hidden="true"></i>
      </a>
    </div>
  </modal>
</template>

<script>
import { RaptorJobs } from '../services/raptor-jobs'

let raptorJobs

export default {
  data () {
    return {
      job: null
    }
  },
  methods: {
    hide () {
      this.$modal.hide('job-log')
    },
    close (close) {
      this.$router.go(-1)
    }
  },
  mounted () {
    this.$modal.show('job-log')

    raptorJobs = new RaptorJobs('arn:aws:lambda:us-east-1:976741133712:function:raptorSchemaJob')

    raptorJobs.getLogs(this.$route.params.jobId, '/aws/batch/job').then((job) => {
      this.$log.debug('Received CloudWatch Logs', job)
      this.job = job
    })
  }
}
</script>

<style>
  .close {
    cursor: pointer;
  }

  .card.border-light {
    border: none;
  }

  pre {
    margin: 0 20px 0 40px;
  }

  .v--modal {
    padding: 5px 10px 0 0 !important;
  }

  .v--modal h4 {
    padding: 15px 0 25px;
  }

  .loading {
    position: relative;
    height: 100%;
  }

  .loading i {
    position: absolute;
    top: calc(50% - 48px);
    left: calc(50% - 48px);
  }
</style>


// WEBPACK FOOTER //
// JobLog.vue?2e76de6a